export default __webpack_public_path__ + "static/couples-61abe1157b0628a91b2800f15fd2b5ed.webp";